module.exports = __webpack_public_path__ + "img/6-digit-code.d1733f35.png";